import { render, staticRenderFns } from "./DuplaChecagem.vue?vue&type=template&id=ff3ff98c&scoped=true&"
import script from "./DuplaChecagem.vue?vue&type=script&lang=js&"
export * from "./DuplaChecagem.vue?vue&type=script&lang=js&"
import style0 from "./DuplaChecagem.vue?vue&type=style&index=0&id=ff3ff98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3ff98c",
  null
  
)

export default component.exports